import React from 'react'
import {Modal} from 'react-bootstrap'
import Container from 'react-bootstrap/Container'
import {Button} from '../../../../_gori/partials/widgets'
import {useIntl} from 'react-intl'
import {blockPopUp} from '../../../../_gori/helpers/BrowserHelpers'
import {toast} from 'react-toastify'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {KTSVG} from '../../../../_gori/helpers'
import {useStatesGlobal} from '../../../../_gori/helpers/components/StatesGlobalProvider'

type Props = {
  show: boolean
  handleClose: () => void
  data: any
}

export const TrackingNumbersDetail: React.FC<Props> = ({show, handleClose, data}) => {
  const {statesGlobal} = useStatesGlobal()
  const carriers = statesGlobal.carriers
  const intl = useIntl()
  const trackingNumbers = data.original?.latest_shipment?.tracking_numbers || []
  const trackingStatus = data.original?.latest_shipment?.tracking_status || ''
  let service = carriers[data.original.carrier + '_' + data.original.service] ?? []

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName='modal-size-lg h-auto'
      contentClassName='modal-padding'
      id='gori_modal_view_tracking_numbers'
      tabIndex={-1}
      aria-hidden='true'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title bsPrefix={'fw-bolder fs-1'}>
          {intl.formatMessage({id: 'TRACKING_NUMBERS'})}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <div className='row'>
            <div className='col-12 d-flex mb-3' style={{color: '#94A3B8'}}>
              <div className='col-6 text-uppercase text-start fw-bolder fs-5 lh-lg'>
                {intl.formatMessage({id: 'TRACKING_NUMBER'})}:
              </div>
              <div className='col-6 text-uppercase text-start fw-bolder fs-5 lh-lg'>
                {intl.formatMessage({id: 'TRACKING_STATUS'})}
              </div>
            </div>
          </div>
          <div className='row'>
            {Object.values(trackingNumbers).map((trackingNumber: any, index) => (
              <div key={index} className='col-12 my-3'>
                <div className='d-flex fs-5 fw-bold'>
                  <div className='col-6 d-flex align-items-center'>
                    <span style={{color: '#A1A5B7', width: '25px'}}>{index + 1}.</span>
                    <span
                      className='text-primary cursor-pointer'
                      onClick={() => {
                        if (blockPopUp(service?.visuals?.tracking_url + trackingNumber)) {
                          toast.warning(intl.formatMessage({id: 'POP_UP_IS_BLOCKED'}))
                        }
                      }}
                    >
                      {trackingNumber}
                    </span>
                    <CopyToClipboard
                      text={trackingNumber}
                      onCopy={() => toast.success(intl.formatMessage({id: 'COPIED'}))}
                    >
                      <div>
                        <div className='btn btn-active-color-primary btn-icon btn-sm btn-outline-light'>
                          <KTSVG path='/media/gori/account/copy.svg' className='svg-icon' />
                        </div>
                      </div>
                    </CopyToClipboard>
                  </div>
                  <div className='col-6 d-flex align-items-center text-capitalize'>
                    {trackingStatus}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className='btn btn-advanced-secondary'
          label={intl.formatMessage({id: 'CLOSE'})}
          loadingText={intl.formatMessage({id: 'CLOSE'})}
          event={handleClose}
        />
      </Modal.Footer>
    </Modal>
  )
}
